import {GridColDef} from "@mui/x-data-grid";

export const getCommonColumnProperties = (properties: Partial<GridColDef>): Partial<GridColDef> => {
    return {...properties, sortable: true, filterable: true};
};
